import { render } from "./ProductImages.vue?vue&type=template&id=4f7a36b0&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"

import "./ProductImages.vue?vue&type=style&index=0&id=4f7a36b0&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7a36b0"]])

export default __exports__